import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M3.5 19.25v-5.577L10.423 12 3.5 10.327V4.75L20.712 12 3.5 19.25Z"
	})
});
export { SvgSend as ReactComponent };
